module.exports = __webpack_public_path__ + "img/02.1f258613.jpg";